document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('spotlight-module-section');

  if (!section) return;

  const mobileBg = section.getAttribute('data-mobile-bg');
  const desktopBg = section.getAttribute('data-desktop-bg');

  function updateBackground() {
    const isMobile = window.innerWidth < 1024;
    const bgImage = isMobile ? mobileBg : desktopBg;
    if (!bgImage) return;
    section.style.backgroundImage = `url('${bgImage}')`;
  }

  // Run on load and resize
  updateBackground();
  window.addEventListener('resize', updateBackground);
});
